import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TlgRealtimeDto } from '@/lib/api/data-contracts';
import { Activity } from 'lucide-react';
import { TankGauge } from './tank-gauge';

interface StoreGaugeCardProps {
  storeName: string;
  tanks: TlgRealtimeDto[];
}

export function StoreGaugeCard({ storeName, tanks }: StoreGaugeCardProps) {
  return (
    <Card className='w-full'>
      <CardHeader>
        <CardTitle className='flex items-center gap-2'>
          <Activity className='w-4 h-4' />
          {storeName} 게이지
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4'>
          {tanks
            .sort((a, b) => (a.tankNo || 0) - (b.tankNo || 0))
            .map((tank, index) => (
              <TankGauge
                key={`${tank.storeCd}-${tank.tankNo}-${index}`}
                tankData={tank}
              />
            ))}
        </div>
      </CardContent>
    </Card>
  );
}
